import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";

const EngagementCard = ({ p }) => (
  <Link
    to={`/portfolio/${p.slug}`}
    data-pg-item
    data-testid={`project-card-${p.slug}`}
    className="group border border-white/10 bg-[#111] hover:bg-[#161616] p-6 flex flex-col transition-colors"
  >
    <div className="flex flex-wrap items-center gap-2">
      <span className="bg-[#e60000] text-white text-[10px] tracking-[0.14em] px-2.5 py-1 uppercase">{p.sector}</span>
      {p.type && <span className="border border-white/20 text-white/80 text-[10px] tracking-[0.14em] px-2.5 py-1 uppercase">{p.type}</span>}
    </div>
    <h3 className="mt-4 font-display text-lg lg:text-xl font-bold text-white leading-snug group-hover:text-[#e60000] transition-colors">{p.title}</h3>
    <p className="mt-2 flex items-center gap-2 text-xs text-white/60"><MapPin className="h-3.5 w-3.5 text-[#e60000]" />{p.location} · {p.geography}</p>
    <p className="mt-3 text-sm text-white/75 leading-relaxed flex-1">{p.summary}</p>
    <span className="mt-5 inline-flex items-center gap-2 text-[11px] tracking-[0.16em] uppercase text-white group-hover:text-[#e60000]">
      View engagement <ArrowUpRight className="h-4 w-4" />
    </span>
  </Link>
);

export default EngagementCard;
